import { useLayoutEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import Footer from "../footer/Footer"
import Header from "../header/Header"

const REVEAL_SELECTOR = `
    .reveal-on-scroll,
    .ex-header .container,
       .service-card-reveal,

    .feature-row > div,
    .services-detail-row > div,
    .services-section-title,
    .counter .cell,
    .basic-5 .container > div,
    .ex-basic-1 .container > *,
        .text-box:not(.contact-form-card),

    iframe,
    .site-footer .footer__brand,
    .site-footer .footer__links-panel,
    .site-footer .footer__contact-panel
`

const Layout = ({ children }) => {
    const location = useLocation()
    const pageRef = useRef(null)

    useLayoutEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual"
        }

        const root = document.documentElement
        const previousScrollBehavior = root.style.scrollBehavior
        root.style.scrollBehavior = "auto"

        window.scrollTo(0, 0)

        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
        const page = pageRef.current
        const frameIds = []

        if (!page) {
            root.style.scrollBehavior = previousScrollBehavior
            return undefined
        }

        const selected = [...page.querySelectorAll(REVEAL_SELECTOR)]

        selected.forEach((item, index) => {
            item.classList.add("reveal-on-scroll")
            item.classList.remove("is-visible")
            item.style.setProperty("--reveal-delay", `${Math.min((index % 7) * 75, 450)}ms`)

            if (item.matches(".service-card-reveal")) item.classList.add("reveal-card")
            if (item.matches(".counter .cell")) item.classList.add("reveal-scale")
            if (item.matches("iframe")) item.classList.add("reveal-right")
        })

        page.getBoundingClientRect()

        if (prefersReducedMotion) {
            selected.forEach((item) => item.classList.add("is-visible"))
            root.style.scrollBehavior = previousScrollBehavior
            return undefined
        }

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible")
                        observer.unobserve(entry.target)
                    }
                })
            },
            { threshold: 0.12, rootMargin: "0px 0px -14% 0px" }
        )

        const firstFrame = requestAnimationFrame(() => {
            window.scrollTo(0, 0)

            const secondFrame = requestAnimationFrame(() => {
                window.scrollTo(0, 0)
                selected.forEach((item) => observer.observe(item))
                root.style.scrollBehavior = previousScrollBehavior
            })

            frameIds.push(secondFrame)
        })

        frameIds.push(firstFrame)

        return () => {
            frameIds.forEach(cancelAnimationFrame)
            observer.disconnect()
            root.style.scrollBehavior = previousScrollBehavior
        }
    }, [location.pathname])

    return (
        <main className="min-h-screen">
            <Header />
            <div ref={pageRef} key={location.pathname}>
                {children}
            </div>
            <Footer />
        </main>
    )
}


export default Layout
